import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _acd60316 = () => interopDefault(import('../pages/404/index.vue' /* webpackChunkName: "pages/404/index" */))
const _25f30a59 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _3d6810e8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _449b5cc3 = () => interopDefault(import('../pages/payment/index.vue' /* webpackChunkName: "pages/payment/index" */))
const _5d52932a = () => interopDefault(import('../pages/policy/index.vue' /* webpackChunkName: "pages/policy/index" */))
const _6686faf2 = () => interopDefault(import('../pages/subscribe/index.vue' /* webpackChunkName: "pages/subscribe/index" */))
const _22ecef8f = () => interopDefault(import('../pages/auth/reset_password/index.vue' /* webpackChunkName: "pages/auth/reset_password/index" */))
const _1b41b412 = () => interopDefault(import('../pages/auth/social-callback/index.vue' /* webpackChunkName: "pages/auth/social-callback/index" */))
const _193f56d5 = () => interopDefault(import('../pages/auth/social-register/index.vue' /* webpackChunkName: "pages/auth/social-register/index" */))
const _7b5474a0 = () => interopDefault(import('../pages/policy/terms.vue' /* webpackChunkName: "pages/policy/terms" */))
const _00955577 = () => interopDefault(import('../pages/product/list/index.vue' /* webpackChunkName: "pages/product/list/index" */))
const _11c1d4d2 = () => interopDefault(import('../pages/subscribe/complete/index.vue' /* webpackChunkName: "pages/subscribe/complete/index" */))
const _3307f7f4 = () => interopDefault(import('../pages/product/detail/_show.vue' /* webpackChunkName: "pages/product/detail/_show" */))
const _2fe47c36 = () => interopDefault(import('../pages/product/search/_search.vue' /* webpackChunkName: "pages/product/search/_search" */))
const _8a715e68 = () => interopDefault(import('../pages/subscribe/checkout/_id.vue' /* webpackChunkName: "pages/subscribe/checkout/_id" */))
const _4bf1b2f0 = () => interopDefault(import('../pages/purchase/_no.vue' /* webpackChunkName: "pages/purchase/_no" */))
const _6497b11c = () => interopDefault(import('../pages/user/_user.vue' /* webpackChunkName: "pages/user/_user" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _acd60316,
    name: "404___zh_tw"
  }, {
    path: "/cart",
    component: _25f30a59,
    name: "cart___zh_tw"
  }, {
    path: "/en",
    component: _3d6810e8,
    name: "index___en"
  }, {
    path: "/ja",
    component: _3d6810e8,
    name: "index___ja"
  }, {
    path: "/payment",
    component: _449b5cc3,
    name: "payment___zh_tw"
  }, {
    path: "/policy",
    component: _5d52932a,
    name: "policy___zh_tw"
  }, {
    path: "/subscribe",
    component: _6686faf2,
    name: "subscribe___zh_tw"
  }, {
    path: "/auth/reset_password",
    component: _22ecef8f,
    name: "auth-reset_password___zh_tw"
  }, {
    path: "/auth/social-callback",
    component: _1b41b412,
    name: "auth-social-callback___zh_tw"
  }, {
    path: "/auth/social-register",
    component: _193f56d5,
    name: "auth-social-register___zh_tw"
  }, {
    path: "/en/404",
    component: _acd60316,
    name: "404___en"
  }, {
    path: "/en/cart",
    component: _25f30a59,
    name: "cart___en"
  }, {
    path: "/en/payment",
    component: _449b5cc3,
    name: "payment___en"
  }, {
    path: "/en/policy",
    component: _5d52932a,
    name: "policy___en"
  }, {
    path: "/en/subscribe",
    component: _6686faf2,
    name: "subscribe___en"
  }, {
    path: "/ja/404",
    component: _acd60316,
    name: "404___ja"
  }, {
    path: "/ja/cart",
    component: _25f30a59,
    name: "cart___ja"
  }, {
    path: "/ja/payment",
    component: _449b5cc3,
    name: "payment___ja"
  }, {
    path: "/ja/policy",
    component: _5d52932a,
    name: "policy___ja"
  }, {
    path: "/ja/subscribe",
    component: _6686faf2,
    name: "subscribe___ja"
  }, {
    path: "/policy/terms",
    component: _7b5474a0,
    name: "policy-terms___zh_tw"
  }, {
    path: "/product/list",
    component: _00955577,
    name: "product-list___zh_tw"
  }, {
    path: "/subscribe/complete",
    component: _11c1d4d2,
    name: "subscribe-complete___zh_tw"
  }, {
    path: "/en/auth/reset_password",
    component: _22ecef8f,
    name: "auth-reset_password___en"
  }, {
    path: "/en/auth/social-callback",
    component: _1b41b412,
    name: "auth-social-callback___en"
  }, {
    path: "/en/auth/social-register",
    component: _193f56d5,
    name: "auth-social-register___en"
  }, {
    path: "/en/policy/terms",
    component: _7b5474a0,
    name: "policy-terms___en"
  }, {
    path: "/en/product/list",
    component: _00955577,
    name: "product-list___en"
  }, {
    path: "/en/subscribe/complete",
    component: _11c1d4d2,
    name: "subscribe-complete___en"
  }, {
    path: "/ja/auth/reset_password",
    component: _22ecef8f,
    name: "auth-reset_password___ja"
  }, {
    path: "/ja/auth/social-callback",
    component: _1b41b412,
    name: "auth-social-callback___ja"
  }, {
    path: "/ja/auth/social-register",
    component: _193f56d5,
    name: "auth-social-register___ja"
  }, {
    path: "/ja/policy/terms",
    component: _7b5474a0,
    name: "policy-terms___ja"
  }, {
    path: "/ja/product/list",
    component: _00955577,
    name: "product-list___ja"
  }, {
    path: "/ja/subscribe/complete",
    component: _11c1d4d2,
    name: "subscribe-complete___ja"
  }, {
    path: "/",
    component: _3d6810e8,
    name: "index___zh_tw"
  }, {
    path: "/en/product/detail/:show?",
    component: _3307f7f4,
    name: "product-detail-show___en"
  }, {
    path: "/en/product/search/:search?",
    component: _2fe47c36,
    name: "product-search-search___en"
  }, {
    path: "/en/subscribe/checkout/:id?",
    component: _8a715e68,
    name: "subscribe-checkout-id___en"
  }, {
    path: "/ja/product/detail/:show?",
    component: _3307f7f4,
    name: "product-detail-show___ja"
  }, {
    path: "/ja/product/search/:search?",
    component: _2fe47c36,
    name: "product-search-search___ja"
  }, {
    path: "/ja/subscribe/checkout/:id?",
    component: _8a715e68,
    name: "subscribe-checkout-id___ja"
  }, {
    path: "/en/purchase/:no?",
    component: _4bf1b2f0,
    name: "purchase-no___en"
  }, {
    path: "/en/user/:user?",
    component: _6497b11c,
    name: "user-user___en"
  }, {
    path: "/ja/purchase/:no?",
    component: _4bf1b2f0,
    name: "purchase-no___ja"
  }, {
    path: "/ja/user/:user?",
    component: _6497b11c,
    name: "user-user___ja"
  }, {
    path: "/product/detail/:show?",
    component: _3307f7f4,
    name: "product-detail-show___zh_tw"
  }, {
    path: "/product/search/:search?",
    component: _2fe47c36,
    name: "product-search-search___zh_tw"
  }, {
    path: "/subscribe/checkout/:id?",
    component: _8a715e68,
    name: "subscribe-checkout-id___zh_tw"
  }, {
    path: "/purchase/:no?",
    component: _4bf1b2f0,
    name: "purchase-no___zh_tw"
  }, {
    path: "/user/:user?",
    component: _6497b11c,
    name: "user-user___zh_tw"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
